import React from "react";

import { IIconType } from "components/shared/icon_types/_prop_interface";

function ChevronDown({ size, color, ...rest }: IIconType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...rest}>
      <path fill={color} d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" />
      <path d="M0-.75h24v24H0z" fill="none" />
    </svg>
  );
}

export default ChevronDown;
